(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-blog-index"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal-padding"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal-performance"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal-responsive"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal-social"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal-v3"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-blog-journal"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-collection-native-test"] && !Shopify.designMode) return;
  try {
    
/* Diamond Studio collection icon library.
 * Crown and setting geometry reused from the approved round-3 collection.
 * Standalone module: no external scripts, images, network requests or SVG IDs.
 */
(() => {
/* Original jewelry and service illustrations. All coordinates use a 96-unit canvas. */
const detailArtwork = (() => {
  const metal = 'fill="var(--icon-metal, #eef0ec)" stroke="currentColor" stroke-width="1.5"';
  const face = 'fill="var(--icon-face, #fffefa)" stroke="currentColor" stroke-width="1.5"';
  const path = (d, attributes = '') => `<path d="${d}" ${attributes}/>`;
  const circle = (x, y, radius, attributes = face) => `<circle cx="${x}" cy="${y}" r="${radius}" ${attributes}/>`;
  const n = value => Number(value.toFixed(2));
  const point = (x, y, radius, angle, squash = 1) => [n(x + Math.cos(angle) * radius), n(y + Math.sin(angle) * radius * squash)];

  // A face-up brilliant crown: a clean octagonal table with facets around it.
  function gem(x, y, radius, squash = .88) {
    const outer = Array.from({ length: 8 }, (_, i) => point(x, y, radius, i * Math.PI / 4, squash));
    const table = Array.from({ length: 8 }, (_, i) => point(x, y, radius * .48, i * Math.PI / 4, squash));
    return `<ellipse cx="${x}" cy="${y}" rx="${radius}" ry="${n(radius * squash)}" ${face}/>` +
      path(`M${table.map(p => p.join(' ')).join('L')}Z`, 'stroke="currentColor" stroke-opacity=".55" stroke-width="1"') +
      path(outer.map((p, i) => `M${p.join(' ')}L${table[i].join(' ')}`).join(''), 'stroke="currentColor" stroke-opacity=".55" stroke-width="1"');
  }

  // The broad closed contour is the metal shank; its inner contour leaves a genuine opening.
  const shank = path('M38 37C26 39 18 49 19 61C20 77 33 86 48 86C64 86 77 75 77 60C77 48 69 40 58 37L56 43C65 46 70 52 70 61C70 72 60 80 48 80C36 80 26 72 26 61C25 52 31 46 40 43Z', metal);
  const shankEdge = path('M21 63C24 76 35 83 48 83C62 83 73 74 75 63', 'stroke="currentColor" stroke-opacity=".28" stroke-width="1"');
  const shoulders = path('M38 37L41 43M58 37L55 43M37 34L40 40L48 44L56 40L59 34', metal);
  const prongs = path('M38 23L40 26M58 23L56 26M38 36L41 33M58 36L55 33', 'stroke="currentColor" stroke-width="2.2"');
  const plainHead = shoulders + gem(48, 29, 13) + prongs;
  const plain = shank + shankEdge + plainHead;

  function meleeRow(x, y, radius, count, stoneRadius, squash = .92, offset = -Math.PI / 2) {
    return Array.from({ length: count }, (_, i) => {
      const [cx, cy] = point(x, y, radius, offset + i * Math.PI * 2 / count, squash);
      return circle(cx, cy, stoneRadius) + path(`M${n(cx - stoneRadius * .42)} ${cy}h${n(stoneRadius * .84)}M${cx} ${n(cy - stoneRadius * .42)}v${n(stoneRadius * .84)}`, 'stroke="currentColor" stroke-opacity=".4" stroke-width=".8"');
    }).join('');
  }

  const classic = path('M37 35C27 37 19 47 19 60C19 76 32 86 48 86C64 86 77 76 77 60C77 47 69 37 59 35L56 45C64 48 69 53 69 61C69 72 60 80 48 80C36 80 27 72 27 61C27 53 32 48 40 45Z', metal) +
    path('M24 62C26 74 36 82 48 82C60 82 70 75 72 63M28 47C33 45 37 40 38 35M68 47C63 45 59 40 58 35', 'stroke="currentColor" stroke-opacity=".35" stroke-width="1"') +
    plainHead;

  const pave = shank + shankEdge +
    [[33,44],[27,50],[23.5,57],[63,44],[69,50],[72.5,57]].map(([x,y]) => circle(x,y,2.8)).join('') + plainHead;

  const halo = shank + shankEdge +
    path('M32 34L39 45M64 34L57 45M36 40Q48 49 60 40', metal) +
    `<ellipse cx="48" cy="29" rx="20" ry="18.4" ${metal}/>` +
    meleeRow(48, 29, 16.8, 12, 2.65) + gem(48, 29, 11) +
    path('M40 22L42 24M56 22L54 24M40 36L42 34M56 36L54 34', 'stroke="currentColor" stroke-width="1.8"');

  const threeStone = shank + shankEdge +
    path('M26 35L32 45M70 35L64 45M33 41L41 39M63 41L55 39', metal) +
    gem(29, 35, 7.8) + gem(67, 35, 7.8) + plainHead +
    path('M24 30L26 32M24 40L26 38M72 30L70 32M72 40L70 38', 'stroke="currentColor" stroke-width="1.7"');

  const engraved = shank + shankEdge +
    path('M33 44C27 46 23 53 23 61M63 44C69 46 73 53 73 61M27 49C24 46 25 43 30 44M25 54C30 53 31 50 28 49M24 59C20 57 19 54 23 53M69 49C72 46 71 43 66 44M71 54C66 53 65 50 68 49M72 59C76 57 77 54 73 53', 'stroke="currentColor" stroke-width="1.05"') + plainHead;

  const doubleHalo = shank + shankEdge +
    path('M29 37L39 46M67 37L57 46M35 43Q48 50 61 43', metal) +
    `<ellipse cx="48" cy="30" rx="24" ry="22" ${metal}/>` +
    meleeRow(48, 30, 20.8, 16, 2.3) +
    `<ellipse cx="48" cy="30" rx="17.6" ry="16.2" ${metal}/>` +
    meleeRow(48, 30, 14.6, 12, 2.05) + gem(48, 30, 9.7) +
    path('M41 24L43 26M55 24L53 26M41 36L43 34M55 36L53 34', 'stroke="currentColor" stroke-width="1.7"');

  // A second complete band is offset alongside the engagement ring, rather than a thickened shank.
  const bridal = path('M87 63A27 26 0 1 1 33 63A27 26 0 1 1 87 63ZM81 63A21 20 0 1 1 39 63A21 20 0 1 1 81 63Z', `${metal} fill-rule="evenodd"`) +
    [[71,44],[77,49],[82,56]].map(([x,y]) => circle(x,y,2.5)).join('') +
    `<g transform="translate(-4 -2)">${plain}</g>`;

  const settings = [plain, classic, pave, halo, threeStone, engraved, doubleHalo, bridal];

  const bands = path('M38 15C22 15 11 28 11 45C11 62 22 76 38 76C54 76 65 62 65 45C65 28 54 15 38 15ZM38 22C49 22 57 32 57 45C57 58 49 69 38 69C27 69 19 58 19 45C19 32 27 22 38 22Z', `${metal} fill-rule="evenodd"`) +
    path('M59 27C43 27 31 40 31 57C31 75 43 88 59 88C75 88 86 75 86 57C86 40 75 27 59 27ZM59 34C70 34 78 44 78 57C78 71 70 81 59 81C48 81 39 71 39 57C39 44 48 34 59 34Z', `${metal} fill-rule="evenodd"`) +
    path('M13 47C14 62 24 73 38 73M34 60C35 75 46 85 59 85', 'stroke="currentColor" stroke-opacity=".25" stroke-width="1"');

  const earrings = path('M33 41L39 24M63 48L73 30M35 23L42 26M69 28L77 32', 'stroke="currentColor" stroke-width="2"') +
    `<ellipse cx="28" cy="45" rx="17" ry="18" ${metal}/><ellipse cx="64" cy="53" rx="17" ry="18" ${metal}/>` +
    gem(28,44,14,1) + gem(64,52,14,1) +
    path('M17 33L20 36M39 33L36 36M17 55L20 52M39 55L36 52M53 41L56 44M75 41L72 44M53 63L56 60M75 63L72 60', 'stroke="currentColor" stroke-width="2.2"');

  const chain = 'M18 9C18 34 24 53 48 67C72 53 78 34 78 9';
  const necklace = path(chain, 'stroke="currentColor" stroke-opacity=".22" stroke-width="2.3"') +
    path(chain, 'stroke="currentColor" stroke-width="1.6" stroke-dasharray="2 2.4"') +
    `<ellipse cx="48" cy="70" rx="3.3" ry="5.3" ${metal}/>` + gem(48,81,8.5,1) +
    path('M42 75L44 77M54 75L52 77M42 87L44 85M54 87L52 85', 'stroke="currentColor" stroke-width="1.7"');

  const bracelet = `<ellipse cx="48" cy="51" rx="31" ry="23" stroke="currentColor" stroke-width="2.4" stroke-opacity=".45"/>` +
    Array.from({length:16},(_,i)=>{
      const a=-Math.PI/2+i*Math.PI/8;
      const x=n(48+Math.cos(a)*31),y=n(51+Math.sin(a)*23);
      return `<g transform="rotate(${n(a*180/Math.PI+90)} ${x} ${y})"><rect x="${n(x-4.1)}" y="${n(y-4.6)}" width="8.2" height="9.2" rx="2.2" ${metal}/>${gem(x,y,3,1)}</g>`;
    }).join('') + `<rect x="43.5" y="23" width="9" height="9" rx="1.5" ${metal}/>` + path('M46 27.5h4','stroke="currentColor" stroke-width="1.1"');

  const gift = path('M20 42H76V85H20ZM16 32H80V43H16Z', metal) +
    path('M43 32H53V85H43Z', face) +
    path('M48 31C29 33 20 26 23 17C26 9 40 12 48 31ZM48 31C67 33 76 26 73 17C70 9 56 12 48 31Z', face) +
    path('M28 18C33 16 40 22 44 28M68 18C63 16 56 22 52 28', 'stroke="currentColor" stroke-opacity=".4" stroke-width="1"');

  const guide = path('M48 22C35 14 21 14 9 18V76C23 72 35 73 48 81C61 73 73 72 87 76V18C75 14 61 14 48 22Z', metal) +
    path('M48 19C38 11 26 10 14 13V69C27 67 39 70 48 77C57 70 69 67 82 69V13C70 10 58 11 48 19Z', face) +
    path('M48 19V77M22 25C28 24 35 26 40 29M22 36C28 35 35 37 40 40M22 47C28 46 35 48 40 51M56 29C61 26 68 24 74 25M56 40C61 37 68 35 74 36M56 51C61 48 68 46 74 47', 'stroke="currentColor" stroke-width="1.3"');

  const certificate = path('M21 10H66L78 22V77H21Z', face) +
    path('M66 10V22H78M31 26H56M31 35H65M31 44H48', 'stroke="currentColor" stroke-width="1.5"') +
    path('M52 69L48 87L60 81L72 87L68 69Z', metal) +
    circle(60,61,14,metal) + circle(60,61,9,face) +
    path('M55 61L59 65L66 57', 'stroke="currentColor" stroke-width="1.8"');

  const shipping = path('M9 24H57V65H9ZM57 37H73L86 51V65H57Z', metal) +
    path('M62 41H71L80 51H62Z', face) +
    circle(26,67,10,face) + circle(73,67,10,face) +
    circle(26,67,3,'fill="currentColor" stroke="none"') + circle(73,67,3,'fill="currentColor" stroke="none"') +
    path('M17 35H39M17 43H32', 'stroke="currentColor" stroke-width="1.8"');

  const returnMark = path('M28 43L51 33L78 43V72L52 84L28 73Z', metal) +
    path('M28 43L52 54L78 43M52 54V84M40 38L65 49V59', 'stroke="currentColor" stroke-width="1.5"') +
    path('M20 35C21 20 33 12 47 12C63 12 75 23 77 35M20 21V35H34', 'stroke="currentColor" stroke-width="2"');

  const support = path('M19 51V39C19 22 32 10 48 10C64 10 77 22 77 39V51', 'stroke="currentColor" stroke-width="3"') +
    path('M24 38C24 24 34 16 48 16C62 16 72 24 72 38', 'stroke="currentColor" stroke-opacity=".25" stroke-width="1"') +
    `<rect x="13" y="39" width="14" height="27" rx="6" ${metal}/><rect x="69" y="39" width="14" height="27" rx="6" ${metal}/>` +
    path('M77 66C77 78 68 83 56 83', 'stroke="currentColor" stroke-width="2"') +
    `<rect x="43" y="78" width="15" height="10" rx="5" ${face}/>`;

  const user = circle(48,29,16,face) + path('M19 85V76C19 61 32 50 48 50C64 50 77 61 77 76V85Z', metal);

  const diamond = path('M11 35L28 15H68L85 35L48 83Z', face) +
    path('M11 35H85M28 15L33 35L48 83L63 35L68 15M28 15L48 35L68 15M33 35L48 15L63 35', 'stroke="currentColor" stroke-opacity=".55" stroke-width="1.3"');

  return {settings, marks:{ring:plain,bands,earrings,necklace,bracelet,gift,guide,certificate,shipping,return:returnMark,support,user,diamond}};
})();

/* Original, representative crown diagrams. Fancy cuts vary in exact faceting. */
const cutArtwork=(()=>{
 const xy=p=>p.map(v=>Math.round(v*100)/100).join(',');
 const points=ps=>ps.map(xy).join(' ');
 const mix=(a,b,t)=>a.map((v,i)=>v+(b[i]-v)*t);
 const polygon=(ps,shade=0)=>`<polygon points="${points(ps)}" fill="currentColor" fill-opacity="${shade}"/>`;
 const table=ps=>`<polygon points="${points(ps)}" fill="var(--icon-face,#fffefa)" stroke="currentColor" stroke-width="1.1" stroke-opacity=".8"/>`;
 const outline=(d,fill=true)=>`<path d="${d}" fill="${fill?'var(--icon-face,#fffefa)':'none'}" stroke="currentColor" stroke-width="1.65"/>`;
 const boundary=(vertices,c=[48,48])=>a=>{
  const ray=[Math.cos(a),Math.sin(a)];let distance=Infinity;
  for(let j=0;j<vertices.length;j++){
   const p=vertices[j],q=vertices[(j+1)%vertices.length],v=[q[0]-p[0],q[1]-p[1]],w=[p[0]-c[0],p[1]-c[1]];
   const det=ray[0]*v[1]-ray[1]*v[0];if(Math.abs(det)<1e-9)continue;
   const t=(w[0]*v[1]-w[1]*v[0])/det,u=(w[0]*ray[1]-w[1]*ray[0])/det;
   if(t>0&&u>=-1e-7&&u<=1.0000001)distance=Math.min(distance,t);
  }
  return [c[0]+ray[0]*distance,c[1]+ray[1]*distance];
 };
 const curved=(start,segments,c=[48,48])=>{
  const vertices=[];let p=start;
  for(const [a,b,q] of segments){for(let i=0;i<24;i++){const t=i/24,s=1-t;vertices.push([0,1].map(k=>s*s*s*p[k]+3*s*s*t*a[k]+3*s*t*t*b[k]+t*t*t*q[k]))}p=q}
  return {d:`M${xy(start)}${segments.map(s=>'C'+s.map(xy).join(' ')).join('')}Z`,at:boundary(vertices,c),center:c};
 };
 function brilliant({d,at,center=[48,48],offset=-Math.PI/2,tableScale=.55,edgeVertices}){
  const step=Math.PI/4,edge=edgeVertices||Array.from({length:8},(_,i)=>at(offset+i*step)),half=edgeVertices?edge.map((p,i)=>mix(p,edge[(i+1)%8],.5)):Array.from({length:8},(_,i)=>at(offset+(i+.5)*step));
  const face=edge.map(p=>mix(center,p,tableScale)),stars=half.map(p=>mix(center,p,.755));let facets='';
  for(let j=0;j<8;j++){
   const next=(j+1)%8,prev=(j+7)%8;
   facets+=polygon([face[j],face[next],stars[j]],[.025,.07,.13,.05,.015,.10,.16,.045][j]);
   facets+=polygon([face[j],stars[j],edge[j],stars[prev]],[.09,.025,.08,.17,.045,.015,.12,.055][j]);
   facets+=polygon([stars[j],edge[j],half[j]],j%2?.14:.035)+polygon([stars[j],half[j],edge[next]],j%2?.025:.11);
  }
  return outline(d)+`<g stroke="currentColor" stroke-width=".8" stroke-opacity=".54" stroke-linejoin="round">${facets}</g>`+table(face)+outline(d,false);
 }
 const clipped=(x,y,w,h,b)=>[[x+b,y],[x+w-b,y],[x+w,y+b],[x+w,y+h-b],[x+w-b,y+h],[x+b,y+h],[x,y+h-b],[x,y+b]];
 const path=ps=>'M'+ps.map(xy).join('L')+'Z';
 function stepCut(vertices){
  const rings=[1,.87,.73,.57].map(s=>vertices.map(p=>mix([48,48],p,s)));let facets='';
  for(let k=0;k<3;k++)for(let j=0;j<8;j++){const t=(j+1)%8;facets+=polygon([rings[k][j],rings[k][t],rings[k+1][t],rings[k+1][j]],[.025,.10,.20,.07,.025,.12,.06,.16][(j+k*2)%8])}
  return outline(path(vertices))+`<g stroke="currentColor" stroke-width=".82" stroke-opacity=".6">${facets}</g>`+table(rings[3])+outline(path(vertices),false);
 }
 function princess(){
  const outside=[[12,12],[84,12],[84,84],[12,84]],inside=[[28,28],[68,28],[68,68],[28,68]];let facets='';
  for(let j=0;j<4;j++){
   const next=(j+1)%4,a=outside[j],b=outside[next],t=inside[j],u=inside[next],m=mix(a,b,.5),q=mix(t,u,.5),star=mix(q,m,.43);
   facets+=polygon([a,t,star],.13)+polygon([a,star,mix(a,b,.25)],.035)+polygon([mix(a,b,.25),star,m],.15);
   facets+=polygon([m,star,mix(a,b,.75)],.045)+polygon([mix(a,b,.75),star,b],.11)+polygon([b,star,u],.04)+polygon([t,u,star],.065);
  }
  return outline(path(outside))+`<g stroke="currentColor" stroke-width=".86" stroke-opacity=".58">${facets}</g>`+table(inside)+outline(path(outside),false);
 }
 const cushion=curved([26,13],[
  [[40,9],[56,9],[70,13]],[[78,16],[80,18],[83,26]],[[87,40],[87,56],[83,70]],[[80,78],[78,80],[70,83]],
  [[56,87],[40,87],[26,83]],[[18,80],[16,78],[13,70]],[[9,56],[9,40],[13,26]],[[16,18],[18,16],[26,13]]
 ]);
 const marquise=curved([48,5],[
  [[61,17],[70,33],[70,48]],[[70,63],[61,79],[48,91]],[[35,79],[26,63],[26,48]],[[26,33],[35,17],[48,5]]
 ]);
 const pear=curved([48,7],[
  [[58,26],[77,42],[77,58]],[[77,75],[64,86],[48,86]],[[32,86],[19,75],[19,58]],[[19,42],[38,26],[48,7]]
 ],[48,53]);
 function heart(){
  const d='M48 24C39 8 25 7 16 17C5 29 13 42 23 53L48 82L73 53C83 42 91 29 80 17C71 7 57 8 48 24Z';
  const edge=[[48,24],[64,10.75],[80,17],[84.375,35.375],[73,53],[60.5,67.5],[48,82],[35.5,67.5],[23,53],[11.625,35.375],[16,17],[32,10.75]];
  const face=[[48,35],[57,27],[67,30],[68,42],[60,53],[54,61],[48,68],[42,61],[36,53],[28,42],[29,30],[39,27]];
  let facets='';
  for(let j=0;j<12;j++){const next=(j+1)%12,star=mix(mix(face[j],face[next],.5),mix(edge[j],edge[next],.5),.56);facets+=polygon([face[j],face[next],star],j%3===0?.14:.04)+polygon([face[j],star,edge[j]],j%2?.12:.035)+polygon([edge[j],star,edge[next]],j%2?.025:.15)+polygon([edge[next],star,face[next]],.07)}
  return outline(d)+`<g stroke="currentColor" stroke-width=".8" stroke-opacity=".5">${facets}</g>`+table(face)+outline(d,false);
 }
 const radiant=clipped(20,8,56,80,8);
 const cuts=[
  brilliant({d:'M84 48A36 36 0 1 1 12 48A36 36 0 1 1 84 48Z',at:a=>[48+36*Math.cos(a),48+36*Math.sin(a)],offset:-Math.PI*3/8,tableScale:.57}),
  brilliant({d:'M76 48A28 40 0 1 1 20 48A28 40 0 1 1 76 48Z',at:a=>[48+28*Math.cos(a),48+40*Math.sin(a)],offset:-Math.PI*3/8,tableScale:.57}),
  stepCut(clipped(23,8,50,80,7)),
  brilliant({d:path(radiant),at:boundary(radiant),edgeVertices:radiant,tableScale:.6}),
  brilliant({...marquise,tableScale:.53}),brilliant({...pear,tableScale:.55}),
  brilliant({...cushion,offset:-Math.PI*3/8,tableScale:.58}),princess(),
  stepCut(clipped(12,12,72,72,13)),heart()
 ];
 const details=detailArtwork;
 const wrap=(body,kind,cls='')=>`<svg class="ds-illustration ds-${kind} ${cls}" viewBox="0 0 96 96" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">${body}</svg>`;
 return{shape:(i,cls='')=>wrap(cuts[i]||cuts[0],'gem',cls),setting:(i,cls='')=>wrap(details.settings[i]||details.settings[0],'setting',cls),mark:(name,cls='')=>wrap(details.marks[name]||details.marks.diamond,'mark',cls)};
})();


  const normalized = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const dimension = (size, fallback) => Number.isFinite(Number(size)) ? Math.max(8, Math.min(256, Number(size))) : fallback;
  const sized = (svg, size, kind) => svg.replace('<svg ', '<svg width="' + size + '" height="' + size + '" ').replace('class="ds-illustration ', 'class="collection-icon collection-' + kind + ' ds-illustration ');
  const shapeNames = ['Round', 'Oval', 'Emerald', 'Radiant', 'Marquise', 'Pear', 'Cushion', 'Princess', 'Asscher', 'Heart'];
  const shapeIndex = Object.fromEntries(shapeNames.map((name, index) => [normalized(name), index]));
  const styleIndex = {solitaire:0, classic:1, pave:2, halo:3, threestone:4, vintage:5, handengraved:5, doublehalo:6, bridalset:7, bridalsets:7};
  // Hidden-halo setting shown in profile: its diamond-set rail sits below the crown,
  // rather than surrounding the diamond face as the Halo setting does.
  const hiddenHalo = '<path d="M34 39C24 44 18 53 18 64C18 80 31 89 48 89C65 89 78 80 78 64C78 53 72 44 62 39L59 45C67 49 71 55 71 64C71 76 61 83 48 83C35 83 25 76 25 64C25 55 29 49 37 45Z" fill="var(--icon-metal,#eef0ec)"/>' +
    '<path d="M32 23L39 12H57L64 23L48 43Z" fill="var(--icon-face,#fffefa)"/><path d="M32 23H64M39 12L42 23L48 43L54 23L57 12M39 12L48 23L57 12" stroke-opacity=".55" stroke-width="1.1"/>' +
    '<path d="M33 21L38 45Q48 50 58 45L63 21M38 45L42 49M58 45L54 49" fill="none"/><path d="M33 33H63V39H33Z" fill="var(--icon-metal,#eef0ec)"/>' +
    [36,42,48,54,60].map(x => '<circle cx="' + x + '" cy="36" r="2.1" fill="var(--icon-face,#fffefa)" stroke-width="1.1"/>').join('');
  const utility = {
    arrow: '<path d="M4 12H20M14 6L20 12L14 18"/>',
    back: '<path d="M20 12H4M10 6L4 12L10 18"/>',
    chevron: '<path d="M6 9L12 15L18 9"/>',
    chevronright: '<path d="M9 6L15 12L9 18"/>',
    close: '<path d="M6 6L18 18M18 6L6 18"/>',
    filter: '<path d="M4 6H9M13 6H20M4 12H15M19 12H20M4 18H5M9 18H20"/><circle cx="11" cy="6" r="2"/><circle cx="17" cy="12" r="2"/><circle cx="7" cy="18" r="2"/>',
    grid2: '<rect x="4" y="4" width="6" height="7" rx=".5"/><rect x="14" y="4" width="6" height="7" rx=".5"/><rect x="4" y="14" width="6" height="6" rx=".5"/><rect x="14" y="14" width="6" height="6" rx=".5"/>',
    grid3: '<path d="M3 4H7V10H3ZM10 4H14V10H10ZM17 4H21V10H17ZM3 14H7V20H3ZM10 14H14V20H10ZM17 14H21V20H17Z"/>',
    list: '<rect x="3" y="4" width="5" height="5" rx=".5"/><rect x="3" y="15" width="5" height="5" rx=".5"/><path d="M12 5H21M12 8H18M12 16H21M12 19H18"/>',
    heart: '<path d="M20.1 4.9A5.2 5.2 0 0 0 12 5.6A5.2 5.2 0 0 0 3.9 4.9C1.8 7 2.1 10.1 4.2 12.4L12 20L19.8 12.4C21.9 10.1 22.2 7 20.1 4.9Z"/>',
    compare: '<path d="M9 4H4V20H9M15 4H20V20H15M9 8H16M13 5L16 8L13 11M15 16H8M11 13L8 16L11 19"/>',
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/>',
    play: '<path d="M9 5L19 12L9 19Z"/>',
    pause: '<path d="M8 5V19M16 5V19"/>',
    check: '<path d="M5 12L9 16L19 6"/>',
    plus: '<path d="M12 5V19M5 12H19"/>',
    minus: '<path d="M5 12H19"/>',
    bag: '<path d="M5 8H19L20 21H4ZM9 9V5a3 3 0 0 1 6 0V9"/>',
    menu: '<path d="M4 6H20M4 12H20M4 18H20"/>',
    spark: '<path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2Z"/>',
    shipping: '<path d="M2 5H14V17H2ZM14 9H18L22 13V17H14M16 10V13H21"/><circle cx="6" cy="18" r="2" fill="var(--icon-face,#fffefa)"/><circle cx="18" cy="18" r="2" fill="var(--icon-face,#fffefa)"/>',
    return: '<path d="M3 7V3M3 7H7M3.3 7A9 9 0 1 1 3 16M9 11L13 9L17 11V17L13 19L9 17ZM9 11L13 13L17 11M13 13V19"/>',
    diamond: '<path d="M3 8L8 3H16L21 8L12 21ZM3 8H21M8 3L12 21L16 3M8 3L12 8L16 3"/>',
    account: '<circle cx="12" cy="7" r="4"/><path d="M4 21V19a8 8 0 0 1 16 0V21"/>',
    star: '<path d="M12 3L14.8 8.7L21 9.6L16.5 14L17.6 20.2L12 17.3L6.4 20.2L7.5 14L3 9.6L9.2 8.7Z"/>',
    reset: '<path d="M3 7V3M3 7H7M3.3 7A9 9 0 1 1 3 16"/>',
    link: '<path d="M10 7L12.5 4.5a5 5 0 0 1 7 7L17 14M14 17L11.5 19.5a5 5 0 0 1-7-7L7 10M8 16L16 8"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11V17M12 7V7.1"/>',
    chat: '<path d="M21 11A9 9 0 0 1 12 20H3L5 16A9 9 0 1 1 21 11Z"/>'
  };
  const utilityAliases = {grid:'grid2',down:'chevron',chevrondown:'chevron',filters:'filter',wishlist:'heart',cart:'bag',user:'account',returns:'return'};
  function icon(name, size = 24) {
    const key = normalized(name), resolved = utilityAliases[key] || key, dim = dimension(size, 24);
    return '<svg class="collection-icon collection-utility" width="' + dim + '" height="' + dim + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' + (utility[resolved] || utility.diamond) + '</svg>';
  }
  window.CollectionIcons = Object.freeze({
    shape(name, size = 32) {
      const key = normalized(name).replace(/cut$/, ''), index = shapeIndex[key] ?? 0;
      return sized(cutArtwork.shape(index), dimension(size, 32), 'shape');
    },
    style(name, size = 32) {
      const key = normalized(name).replace(/rings?$/, ''), dim = dimension(size, 32);
      if (key === 'hiddenhalo') return '<svg class="collection-icon collection-style ds-illustration ds-setting" width="' + dim + '" height="' + dim + '" viewBox="0 0 96 96" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' + hiddenHalo + '</svg>';
      return sized(cutArtwork.setting(styleIndex[key] ?? 0), dim, 'style');
    },
    icon,
    shapeNames: Object.freeze(shapeNames),
    styleNames: Object.freeze(['Solitaire', 'Classic', 'Hand Engraved', 'Pave', 'Halo', 'Three Stone', 'Hidden Halo', 'Double Halo', 'Bridal Sets'])
  });
})();

(() => {
  'use strict';
  if (window.DSCollectionProducts) { window.DSCollectionProducts.init(); return; }
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const paths = {close:'M6 6l12 12M18 6 6 18', arrow:'M4 12h16m-6-6 6 6-6 6', back:'M20 12H4m6-6-6 6 6 6', play:'m9 5 10 7-10 7Z', check:'m5 12 4 4L19 6', plus:'M12 5v14M5 12h14'};
  const icon = name => '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (paths[name] || paths.arrow) + '"/></svg>';
  const defaults = {detail_title:'Every detail, up close.',close_details:'Close product details',was:'Was',gold_options:'Gold options',choose_gold:'Choose a gold option',gold_note:'Choose your metal and size on the product page. These options show the current ring price plus any gold upgrade.',gold_total:'Includes the selected gold upgrade.',view_product:'View product & options',unavailable:'Currently unavailable',photo:'View photograph {number}',video:'Click here for video',previous:'Previous photograph',next:'Next photograph',image_count:'{current} / {total}',shape:'Diamond shape',setting:'Ring setting',carat:'Stated carat weight',carat_unit:'ct',compare:'Compare',compare_title:'A closer comparison.',close_compare:'Close comparison',compare_min:'Select at least two pieces to compare.',compare_max:'You can compare up to three pieces. Remove one to add another.',compare_count:'{count} of 3 pieces',compare_added:'Added to comparison.',compare_removed:'Removed from comparison.',remove_comparison:'Remove {name} from comparison',clear:'Clear',current_gold:'Gold preference',base_gold:'See product options',comparison_label:'Product comparison; scroll horizontally to see all pieces',no_photo:'View photographs on the product page',play_error:'Use the video controls to start playback.',saved_name:'Saved {name}',save_name:'Save {name}',saved_title:'Your saved pieces.',close_saved:'Close saved pieces',saved_intro:'A little inspiration, kept close.',saved_loading:'Loading your saved pieces…',saved_empty:'Your next favorite is waiting.',saved_empty_copy:'Tap the heart on a piece to keep it here.',saved_count:'{count} saved pieces',saved_count_one:'1 saved piece',saved_remove:'Remove {name} from saved pieces',saved_remove_label:'Remove',saved_removing:'Removing…',saved_remove_error:'This piece could not be removed. Please try again.',saved_load_error:'This saved piece could not be loaded.',saved_retry:'Try again',saved_more:'Show more saved pieces',keep_exploring:'Keep exploring'};
  let strings = {...defaults}, activeProduct = null, imageIndex = 0, comparison = [], currency = '', notificationTimer;
  const products = new Map(), goldSelections = new Map(), wiredCards = new WeakSet(), savedProducts = new Map();
  let savedLimit = 12, savedSerial = 0, savedController = null, savedMutation = false;
  const text = (key, values = {}) => Object.entries(values).reduce((output, [name, value]) => output.replaceAll('{' + name + '}', String(value)), strings[key] || defaults[key] || key);
  const rootFor = () => $('.ds-collection') || document;
  function readStrings() {
    const node = $('[data-dsc-strings]');
    if (node) { try { strings = {...defaults, ...JSON.parse(node.textContent)}; } catch (_) {} }
    if (window.DSCollectionStrings) strings = {...strings, ...window.DSCollectionStrings};
  }
  function selectedGold(p) {
    const selected = p.gold?.find(option => option.label === goldSelections.get(String(p.id)) && option.available);
    return selected || null;
  }
  function priceMarkup(p) {
    const selection = selectedGold(p);
    const price = selection?.priceText || p.priceText;
    const compare = p.compare > p.price ? (selection?.compareText || p.compareText) : null;
    return '<strong>' + escapeHTML(price) + '</strong>' + (compare ? '<span>' + escapeHTML(text('was')) + ' <del>' + escapeHTML(compare) + '</del></span>' : '');
  }
  function route(href) {
    if (typeof window.DSCollection?.route === 'function') return String(window.DSCollection.route(href));
    return typeof window.DS_PRODUCT_ROUTE === 'function' ? window.DS_PRODUCT_ROUTE(href) : href;
  }
  function persistComparison() {
    try { sessionStorage.setItem('ds-collection-compare-v1', JSON.stringify({currency, products:comparison.map(id => ({...products.get(id), selectedGold:goldSelections.get(id) || ''}))})); } catch (_) {}
  }
  function restoreComparison(currentCurrency) {
    if (currency) return;
    currency = currentCurrency;
    try {
      const saved = JSON.parse(sessionStorage.getItem('ds-collection-compare-v1') || '{}');
      if (saved.currency !== currency || !Array.isArray(saved.products)) return;
      saved.products.slice(0,3).forEach(p => {
        if (!p || !p.id || typeof p.title !== 'string' || !Array.isArray(p.images) || typeof p.url !== 'string' || !p.url.startsWith('/')) return;
        const id = String(p.id);
        products.set(id,p); comparison.push(id);
        if (p.selectedGold) goldSelections.set(id,p.selectedGold);
      });
    } catch (_) {}
  }
  function notify(message) {
    let node = $('#dsc-notification');
    if (!node) {
      node = document.createElement('div'); node.id = 'dsc-notification'; node.className = 'dsc-notification'; node.setAttribute('role','status'); node.setAttribute('aria-live','polite'); document.body.append(node);
    }
    node.textContent = message; node.hidden = false;
    clearTimeout(notificationTimer); notificationTimer = setTimeout(() => { node.hidden = true; }, 3500);
  }
  function stopVideo() {
    $$('#dsc-detail-dialog video').forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); video.remove(); });
  }
  function dialog(id, className) {
    let node = document.getElementById(id);
    if (node) return node;
    node = document.createElement('dialog'); node.id = id; node.className = 'dsc-dialog ' + className;
    node.addEventListener('close', () => { if (id === 'dsc-detail-dialog') stopVideo(); if (id === 'dsc-saved-dialog') { savedSerial++; savedController?.abort(); } if (node.returnFocus?.isConnected) node.returnFocus.focus({preventScroll:true}); else $('.ds-collection button,.ds-collection a')?.focus({preventScroll:true}); });
    node.addEventListener('click', event => { if (event.target !== node) return; const rect = node.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) node.close(); });
    document.body.append(node); return node;
  }
  function openDialog(node, trigger) {
    if (node.open) return;
    node.returnFocus = trigger || document.activeElement;
    node.showModal();
  }
  function header(title, headingId, closeLabel) {
    return '<div class="dsc-dialog__header"><h2 id="' + headingId + '">' + escapeHTML(title) + '</h2><button type="button" data-dsc-close aria-label="' + escapeHTML(closeLabel) + '">' + icon('close') + '</button></div>';
  }
  function weightLabel(p) {
    if (typeof p.weightText === 'string') return p.weightText;
    if (p.weight == null) return '';
    const value = String(p.weight).trim();
    return /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value) ? value + ' ' + text('carat_unit') : value;
  }
  function specs(p) {
    const pairs = [[text('shape'),p.shape],[text('setting'),p.setting],[text('carat'),weightLabel(p)]];
    return '<dl class="dsc-detail__specs">' + pairs.filter(([,value]) => value != null && String(value).trim()).map(([label,value]) => '<div><dt>' + escapeHTML(label) + '</dt><dd>' + escapeHTML(value) + '</dd></div>').join('') + '</dl>';
  }
  function detail(p, trigger, film = false) {
    if (!p) return;
    stopVideo(); activeProduct = p; imageIndex = 0;
    const d = dialog('dsc-detail-dialog','dsc-detail'); d.setAttribute('aria-labelledby','dsc-detail-title');
    const first = p.images?.[0], gold = selectedGold(p);
    d.innerHTML = header(text('detail_title'),'dsc-detail-title',text('close_details')) + '<div class="dsc-detail__layout"><div class="dsc-detail__media"><div class="dsc-detail__stage" data-dsc-stage>' + (first ? '<img data-dsc-detail-image src="' + escapeHTML(first.src) + '" alt="' + escapeHTML(first.alt || p.title) + '" width="' + Number(first.width || 720) + '" height="' + Number(first.height || 720) + '">' : '<p>' + escapeHTML(text('no_photo')) + '</p>') + '</div><div class="dsc-detail__navigation"><button type="button" data-dsc-previous aria-label="' + escapeHTML(text('previous')) + '"' + (p.images.length < 2 ? ' disabled' : '') + '>' + icon('back') + '</button><span data-dsc-image-count aria-live="polite">' + escapeHTML(text('image_count',{current:1,total:p.images.length})) + '</span><button type="button" data-dsc-next aria-label="' + escapeHTML(text('next')) + '"' + (p.images.length < 2 ? ' disabled' : '') + '>' + icon('arrow') + '</button></div><div class="dsc-detail__thumbnails">' + (p.video ? '<button type="button" class="dsc-detail__video-choice" data-dsc-detail-video aria-label="' + escapeHTML(text('video')) + '" aria-pressed="false">' + icon('play') + '<span>' + escapeHTML(text('video')) + '</span></button>' : '') + p.images.map((image,index) => '<button type="button" data-dsc-image="' + index + '" aria-label="' + escapeHTML(text('photo',{number:index + 1})) + '" aria-pressed="' + (index === 0) + '"><img src="' + escapeHTML(image.thumb) + '" alt="" loading="lazy" width="48" height="48"></button>').join('') + '</div></div><div class="dsc-detail__copy"><h3' + (p.name === p.title ? ' class="dsc-detail__full-title"' : '') + '>' + escapeHTML(p.name || p.title) + '</h3><p class="dsc-detail__description"' + (p.name === p.title ? ' hidden' : '') + '>' + escapeHTML(p.title) + '</p><div class="dsc-detail__prices" data-dsc-detail-prices aria-live="polite" aria-atomic="true">' + priceMarkup(p) + '</div>' + specs(p) + (p.gold?.length ? '<label class="dsc-detail__gold-label" for="dsc-detail-gold">' + escapeHTML(text('gold_options')) + '</label><select id="dsc-detail-gold" data-dsc-detail-gold><option value="">' + escapeHTML(text('choose_gold')) + '</option>' + p.gold.map((option,index) => '<option value="' + index + '"' + (gold?.label === option.label ? ' selected' : '') + (!option.available ? ' disabled' : '') + '>' + escapeHTML(option.label + ' · ' + option.priceText) + '</option>').join('') + '</select><p class="dsc-detail__note">' + escapeHTML(text('gold_note')) + '</p><p class="dsc-detail__note" data-dsc-upgrade-note' + (!gold?.extra ? ' hidden' : '') + '>' + escapeHTML(text('gold_total')) + '</p>' : '') + (!p.available ? '<p class="dsc-detail__availability">' + escapeHTML(text('unavailable')) + '</p>' : '') + '<a class="dsc-solid-button" href="' + escapeHTML(route(p.url)) + '">' + escapeHTML(text('view_product')) + icon('arrow') + '</a><button type="button" class="dsc-detail__compare" data-dsc-detail-compare aria-pressed="' + comparison.includes(String(p.id)) + '">' + icon('plus') + escapeHTML(text('compare')) + '</button></div></div>';
    openDialog(d,trigger); if (film) playVideo();
  }
  function showImage(index) {
    const p = activeProduct; if (!p?.images.length) return;
    stopVideo(); imageIndex = (index + p.images.length) % p.images.length;
    const image = p.images[imageIndex], stage = $('[data-dsc-stage]');
    stage.innerHTML = '<img data-dsc-detail-image src="' + escapeHTML(image.src) + '" alt="' + escapeHTML(image.alt || p.title) + '" width="' + Number(image.width || 720) + '" height="' + Number(image.height || 720) + '">';
    $$('[data-dsc-image]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.dscImage) === imageIndex)));
    $('[data-dsc-detail-video]')?.setAttribute('aria-pressed','false');
    $('[data-dsc-image-count]').textContent = text('image_count',{current:imageIndex + 1,total:p.images.length});
  }
  function playVideo() {
    const p = activeProduct; if (!p?.video) return;
    stopVideo(); const stage = $('[data-dsc-stage]'); stage.innerHTML = '';
    const video = document.createElement('video'); video.controls = true; video.playsInline = true; video.preload = 'none'; video.poster = p.video.poster || ''; video.src = p.video.src; video.setAttribute('aria-label',p.title + ' — ' + text('video')); stage.append(video);
    $$('[data-dsc-image]').forEach(button => button.setAttribute('aria-pressed','false')); $('[data-dsc-detail-video]')?.setAttribute('aria-pressed','true');
    $('[data-dsc-image-count]').textContent = text('video'); video.play().catch(() => { /* Native controls remain available when autoplay is denied. */ });
  }
  function updateCards(id) {
    const p = products.get(String(id)); if (!p) return;
    const selection = selectedGold(p);
    $$('[data-dsc-card]').filter(card => card.dataset.dscId === String(id)).forEach(card => {
      $('[data-dsc-prices]',card).innerHTML = priceMarkup(p);
      const caption = $('[data-dsc-gold-caption]',card); if (caption) caption.textContent = selection?.label || text('gold_options');
      $$('[data-dsc-gold]',card).forEach(button => button.setAttribute('aria-pressed',String(p.gold[Number(button.dataset.dscGold)]?.label === selection?.label)));
    });
    if (String(activeProduct?.id) === String(id) && $('#dsc-detail-dialog')?.open) {
      $('[data-dsc-detail-prices]').innerHTML = priceMarkup(p);
      const note = $('[data-dsc-upgrade-note]'); if (note) note.hidden = !selection?.extra;
      const select = $('[data-dsc-detail-gold]'); if (select) select.value = selection ? String(p.gold.indexOf(selection)) : '';
    }
    persistComparison();
  }
  function chooseGold(p,index) {
    if (!p) return;
    const option = p.gold?.[index];
    if (option && !option.available) return;
    if (option) goldSelections.set(String(p.id),option.label); else goldSelections.delete(String(p.id));
    updateCards(p.id);
  }
  function updateComparison() {
    let host = $('#dsc-compare-tray');
    if (!host) { host = document.createElement('div'); host.id = 'dsc-compare-tray'; document.body.append(host); }
    host.hidden = !comparison.length;
    host.innerHTML = comparison.length ? '<div class="dsc-compare-tray"><div class="dsc-compare-tray__images">' + comparison.map(id => {const p = products.get(id);return p?.images[0] ? '<img src="' + escapeHTML(p.images[0].thumb) + '" alt="' + escapeHTML(p.name) + '" width="40" height="40">' : '';}).join('') + '</div><span>' + escapeHTML(text('compare_count',{count:comparison.length})) + '</span><button type="button" data-dsc-compare-open' + (comparison.length < 2 ? ' disabled' : '') + '>' + escapeHTML(text('compare')) + icon('arrow') + '</button><button type="button" class="dsc-compare-tray__clear" data-dsc-compare-clear>' + escapeHTML(text('clear')) + '</button></div>' : '';
    $$('[data-dsc-card]').forEach(card => $('[data-dsc-compare]',card)?.setAttribute('aria-pressed',String(comparison.includes(card.dataset.dscId))));
    $('[data-dsc-detail-compare]')?.setAttribute('aria-pressed',String(comparison.includes(String(activeProduct?.id))));
    persistComparison();
  }
  function toggleCompare(p) {
    if (!p) return;
    const id = String(p.id), index = comparison.indexOf(id);
    if (index >= 0) { comparison.splice(index,1); notify(text('compare_removed')); }
    else if (comparison.length < 3) { comparison.push(id); notify(text('compare_added')); }
    else { notify(text('compare_max')); return; }
    updateComparison();
  }
  function compare(trigger) {
    if (comparison.length < 2) { notify(text('compare_min')); return; }
    const d = dialog('dsc-compare-dialog','dsc-comparison'); d.setAttribute('aria-labelledby','dsc-compare-title');
    d.innerHTML = header(text('compare_title'),'dsc-compare-title',text('close_compare')) + '<div class="dsc-comparison__scroll" tabindex="0" role="region" aria-label="' + escapeHTML(text('comparison_label')) + '"><div class="dsc-comparison__grid" style="--dsc-columns:' + comparison.length + '">' + comparison.map(id => {
      const p = products.get(id), gold = selectedGold(p), photo = p.images[0];
      return '<article class="dsc-comparison__item">' + (photo ? '<img src="' + escapeHTML(photo.card || photo.src) + '" alt="' + escapeHTML(photo.alt || p.title) + '" width="400" height="400">' : '') + '<h3>' + escapeHTML(p.name || p.title) + '</h3><p>' + escapeHTML(p.title) + '</p><div class="dsc-detail__prices">' + priceMarkup(p) + '</div>' + specs(p) + (gold ? '<div class="dsc-comparison__gold"><span>' + escapeHTML(text('current_gold')) + '</span><strong>' + escapeHTML(gold.label) + '</strong></div>' : '') + '<a class="dsc-outline-button" href="' + escapeHTML(route(p.url)) + '">' + escapeHTML(text('view_product')) + icon('arrow') + '</a><button type="button" class="dsc-comparison__remove" data-dsc-compare-remove="' + id + '" aria-label="' + escapeHTML(text('remove_comparison',{name:p.title})) + '">' + icon('close') + escapeHTML(text('clear')) + '</button></article>';
    }).join('') + '</div></div>';
    openDialog(d,trigger);
  }
  function loadAlternate(card) {
    const img = $('[data-dsc-alternate]',card); if (!img || img.getAttribute('src')) return;
    img.addEventListener('load',() => card.classList.add('dsc-card--alternate-ready'),{once:true});
    img.addEventListener('error',() => card.classList.remove('dsc-card--alternate-ready'),{once:true});
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
  }
  function nativeSavedHandles() {
    try {
      const list = typeof getWishlist === 'function' ? getWishlist() : (localStorage.getItem('shopify-wishlist') || '').split(',');
      return [...new Set(list.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle)).map(handle => handle.toLowerCase()))];
    } catch (_) { return []; }
  }
  function syncNativeSaved() {
    if (!$('.ds-collection')) return;
    const saved = nativeSavedHandles();
    $$('[data-saved-count]').forEach(node => { node.hidden = !saved.length; node.textContent = String(saved.length); });
    $$('[data-dsc-card] [button-wishlist]').forEach(button => button.classList.toggle('active',saved.includes(button.dataset.productHandle)));
  }
  function savedCard(p, handle) {
    const image = p?.images?.[0], title = p?.title || text('saved_load_error');
    return '<article class="dsc-saved__item" data-dsc-saved-handle="' + escapeHTML(handle) + '">' + (p ? '<a class="dsc-saved__image" href="' + escapeHTML(route(p.url)) + '" tabindex="-1" aria-hidden="true">' + (image ? '<img src="' + escapeHTML(image.card || image.src) + '" alt="" width="400" height="400" loading="lazy">' : '') + '</a>' : '<div class="dsc-saved__image dsc-saved__missing">' + icon('close') + '</div>') + '<h3>' + (p ? '<a href="' + escapeHTML(route(p.url)) + '">' + escapeHTML(title) + '</a>' : escapeHTML(title)) + '</h3>' + (p ? '<div class="dsc-detail__prices">' + priceMarkup({...p,gold:[]}) + '</div>' + (!p.available ? '<p class="dsc-saved__availability">' + escapeHTML(text('unavailable')) + '</p>' : '') : '') + '<button type="button" class="dsc-saved__remove" data-dsc-saved-remove="' + escapeHTML(handle) + '" aria-label="' + escapeHTML(text('saved_remove',{name:p?.title || handle})) + '">' + icon('close') + escapeHTML(text('saved_remove_label')) + '</button></article>';
  }
  async function fetchSavedProduct(handle, signal) {
    const response = await fetch(route('/products/' + encodeURIComponent(handle) + '.js'),{credentials:'same-origin',headers:{Accept:'application/json'},signal});
    if (!response.ok) throw new Error('Saved product unavailable');
    const data = await response.json(), variant = data.variants?.find(item => item.available) || data.variants?.[0];
    const currentCurrency = $('.ds-collection')?.dataset.currency || currency;
    if (!data.id || data.handle !== handle || !variant || !Number.isFinite(variant.price) || !currentCurrency) throw new Error('Saved product data unavailable');
    const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:currentCurrency,currencyDisplay:'code'}).format(value / 100);
    const url = new URL('/products/' + encodeURIComponent(handle),location.origin); url.searchParams.set('variant',String(variant.id));
    const source = variant.featured_image?.src || data.featured_image;
    let image = null;
    if (source) {
      const imageURL = new URL(source,location.origin);
      if (imageURL.protocol === 'https:' || imageURL.origin === location.origin) { imageURL.searchParams.set('width','480'); image = {src:imageURL.href,card:imageURL.href,alt:data.title}; }
    }
    const p = {id:String(data.id),handle,title:data.title,name:data.title,url:url.pathname + url.search,available:Boolean(variant.available),price:variant.price,compare:Number(variant.compare_at_price || 0),priceText:format(variant.price),compareText:variant.compare_at_price > variant.price ? format(variant.compare_at_price) : '',currency:currentCurrency,images:image ? [image] : [],gold:[]};
    savedProducts.set(handle,p); return p;
  }
  async function renderSaved() {
    const d = $('#dsc-saved-dialog'); if (!d?.open) return;
    const ticket = ++savedSerial; savedController?.abort(); savedController = new AbortController();
    const handles = nativeSavedHandles(), visible = handles.slice(0,savedLimit), content = $('[data-dsc-saved-content]',d);
    if (!handles.length) {
      content.innerHTML = '<div class="dsc-saved__empty"><h3>' + escapeHTML(text('saved_empty')) + '</h3><p>' + escapeHTML(text('saved_empty_copy')) + '</p><button type="button" class="dsc-solid-button" data-dsc-close>' + escapeHTML(text('keep_exploring')) + icon('arrow') + '</button></div>'; return;
    }
    const missing = visible.filter(handle => !savedProducts.has(handle));
    if (missing.length) {
      content.innerHTML = '<p class="dsc-saved__status" role="status" aria-live="polite">' + escapeHTML(text('saved_loading')) + '</p>';
      const queue = [...missing], signal = savedController.signal;
      await Promise.all(Array.from({length:Math.min(3,queue.length)},async () => {
        while (queue.length && !signal.aborted) { const handle = queue.shift(); try { await fetchSavedProduct(handle,signal); } catch (_) {} }
      }));
    }
    if (ticket !== savedSerial || !d.open) return;
    const failed = visible.some(handle => !savedProducts.has(handle));
    content.innerHTML = '<p class="dsc-saved__summary" role="status">' + escapeHTML(text(handles.length === 1 ? 'saved_count_one' : 'saved_count',{count:handles.length})) + '</p><p class="dsc-saved__error" data-dsc-saved-error role="alert" hidden></p><div class="dsc-saved__grid">' + visible.map(handle => savedCard(savedProducts.get(handle),handle)).join('') + '</div>' + (failed ? '<button type="button" class="dsc-outline-button" data-dsc-saved-retry>' + escapeHTML(text('saved_retry')) + '</button>' : '') + (handles.length > visible.length ? '<button type="button" class="dsc-solid-button" data-dsc-saved-more>' + escapeHTML(text('saved_more')) + icon('arrow') + '</button>' : '');
  }
  function openSaved(trigger) {
    $('[data-ds-shared-header] [data-dsh-close]')?.click();
    const d = dialog('dsc-saved-dialog','dsc-saved'); d.setAttribute('aria-labelledby','dsc-saved-title');
    d.innerHTML = header(text('saved_title'),'dsc-saved-title',text('close_saved')) + '<p class="dsc-saved__intro">' + escapeHTML(text('saved_intro')) + '</p><div class="dsc-saved__content" data-dsc-saved-content></div>';
    savedLimit = 12; openDialog(d,trigger); renderSaved();
  }
  async function removeSaved(handle, button) {
    if (savedMutation) return;
    savedMutation = true; button.disabled = true; button.textContent = text('saved_removing');
    const d = $('#dsc-saved-dialog'), siblings = $$('[data-dsc-saved-remove]',d), index = siblings.indexOf(button);
    try {
      if (typeof updateWishlist !== 'function') throw new Error('Native wishlist unavailable');
      if (nativeSavedHandles().includes(handle)) await updateWishlist(handle);
      syncNativeSaved(); initNativeWishlist(); savedMutation = false;
      if (d.open) { await renderSaved(); const next = $$('[data-dsc-saved-remove]',d); (next[Math.min(index,next.length - 1)] || $('[data-dsc-close]',d))?.focus({preventScroll:true}); }
    } catch (_) {
      savedMutation = false; button.disabled = false; button.innerHTML = icon('close') + escapeHTML(text('saved_remove_label'));
      const error = $('[data-dsc-saved-error]',d); if (error) { error.hidden = false; error.textContent = text('saved_remove_error'); }
    }
  }
  function initNativeWishlist() {
    // The theme's native handler owns guest storage and customer-account sync.
    // Its top-level lexical binding is not exported on window; it also guards
    // repeated initialization with data-wishlist-bound on each button.
    try { if (typeof initButtons === 'function') initButtons('.ds-collection'); } catch (_) {}
  }
  function init(root = document) {
    readStrings();
    $$('[data-dsc-card]',root).forEach(card => {
      if (wiredCards.has(card)) return;
      let p; try { p = JSON.parse($('[data-dsc-product]',card).textContent); } catch (_) { return; }
      if (currency && p.currency && currency !== p.currency) { currency = ''; comparison = []; products.clear(); goldSelections.clear(); savedProducts.clear(); }
      restoreComparison(p.currency); products.set(String(p.id),p); savedProducts.set(p.handle,p); wiredCards.add(card);
      const photo = $('.dsc-card__photo',card);
      photo?.addEventListener('pointerenter',event => { if (event.pointerType !== 'touch') loadAlternate(card); },{passive:true});
      photo?.addEventListener('focusin',() => loadAlternate(card));
      const save = $('[button-wishlist]',card);
      if (save) {
        const syncSave = () => {
          const saved = save.classList.contains('active'); save.setAttribute('aria-pressed',String(saved)); save.setAttribute('aria-label',text(saved ? 'saved_name' : 'save_name',{name:p.title}));
          if (!save.querySelector('[data-dsc-save-glyph]')) save.insertAdjacentHTML('beforeend','<svg data-dsc-save-glyph width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.1 4.9A5.2 5.2 0 0 0 12 5.6A5.2 5.2 0 0 0 3.9 4.9C1.8 7 2.1 10.1 4.2 12.4L12 20L19.8 12.4C21.9 10.1 22.2 7 20.1 4.9Z"/></svg>');
        };
        new MutationObserver(syncSave).observe(save,{attributes:true,attributeFilter:['class'],childList:true}); syncSave();
      }
      updateCards(p.id);
    });
    initNativeWishlist();
    syncNativeSaved();
    updateComparison();
  }
  document.addEventListener('click',event => {
    const button = event.target.closest('button,a'); if (!button) return;
    const card = button.closest('[data-dsc-card]'), p = card ? products.get(card.dataset.dscId) : null;
    if (button.matches('[data-dsc-quick]')) { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); detail(p,button); }
    else if (button.matches('[data-dsc-film]')) detail(p,button,true);
    else if (button.matches('[data-dsc-gold]')) chooseGold(p,Number(button.dataset.dscGold));
    else if (button.matches('[data-dsc-compare]')) toggleCompare(p);
    else if (button.matches('[data-dsc-saved-remove]')) removeSaved(button.dataset.dscSavedRemove,button);
    else if (button.matches('[data-dsc-saved-retry]')) renderSaved().then(() => { if ($('#dsc-saved-dialog')?.open) $('.dsc-saved__item h3 a,[data-dsc-saved-remove]',$('#dsc-saved-dialog'))?.focus(); });
    else if (button.matches('[data-dsc-saved-more]')) { const start = savedLimit; savedLimit += 12; renderSaved().then(() => { if ($('#dsc-saved-dialog')?.open) $$('.dsc-saved__item h3 a')[start]?.focus(); }); }
    else if (button.matches('[data-dsc-close]')) button.closest('dialog')?.close();
    else if (button.matches('[data-dsc-image]')) showImage(Number(button.dataset.dscImage));
    else if (button.matches('[data-dsc-previous]')) showImage(imageIndex - 1);
    else if (button.matches('[data-dsc-next]')) showImage(imageIndex + 1);
    else if (button.matches('[data-dsc-detail-video]')) playVideo();
    else if (button.matches('[data-dsc-detail-compare]')) toggleCompare(activeProduct);
    else if (button.matches('[data-dsc-compare-open]')) compare(button);
    else if (button.matches('[data-dsc-compare-clear]')) { comparison = []; updateComparison(); }
    else if (button.matches('[data-dsc-compare-remove]')) {
      comparison = comparison.filter(id => id !== button.dataset.dscCompareRemove); updateComparison();
      if (comparison.length < 2) $('#dsc-compare-dialog')?.close(); else { compare(); $('[data-dsc-compare-remove]')?.focus(); }
    }
  });
  document.addEventListener('change',event => { if (event.target.matches('[data-dsc-detail-gold]') && activeProduct) chooseGold(activeProduct,event.target.value === '' ? -1 : Number(event.target.value)); });
  document.addEventListener('keydown',event => {
    if (!$('#dsc-detail-dialog')?.open || !['ArrowLeft','ArrowRight'].includes(event.key) || event.target.closest('video,select,input,textarea') || $('[data-dsc-stage] video')) return;
    event.preventDefault(); showImage(imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
  });
  document.addEventListener('click',event => {
    const trigger = event.target.closest('[data-saved-open]');
    if (!trigger || !$('.ds-collection')) return;
    event.preventDefault(); event.stopImmediatePropagation(); openSaved(trigger);
  },true);
  document.addEventListener('shopify-wishlist:updated',() => { syncNativeSaved(); if (!savedMutation && $('#dsc-saved-dialog')?.open) renderSaved(); });
  window.addEventListener('storage',event => { if (event.key === 'shopify-wishlist') { syncNativeSaved(); if ($('#dsc-saved-dialog')?.open) renderSaved(); } });
  document.addEventListener('ds:collection:updated',event => init(event.detail?.root || rootFor()));
  window.addEventListener('load',initNativeWishlist,{once:true});
  document.addEventListener('visibilitychange',() => { if (document.hidden) $$('#dsc-detail-dialog video').forEach(video => video.pause()); });
  window.DSCollectionProducts = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
})();
(() => {
 'use strict';
 let activeRoot,controller,serial=0,headerObserver,infiniteObserver,loading=false,autoFailed=false;
 const $=(s,r=activeRoot)=>r?.querySelector(s),$$=(s,r=activeRoot)=>[...(r?.querySelectorAll(s)||[])];
 const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const extraIcons={Baguette:'<rect x="7" y="2" width="10" height="20"/><path d="M9 5h6v14H9zM7 2l2 3m8-3-2 3M7 22l2-3m8 3-2-3"/>',Shaped:'<path d="m12 2 7 5v9l-7 6-7-6V7l7-5Zm0 0v20M5 7h14M5 16h14"/>',Mixed:'<circle cx="8" cy="9" r="5"/><path d="m16 8 5 7-5 7-5-7 5-7Z"/>',bracelet:'<ellipse cx="12" cy="12" rx="8" ry="9"/><ellipse cx="12" cy="12" rx="5" ry="6"/>',tennis:'<ellipse cx="12" cy="12" rx="7" ry="8"/><circle cx="12" cy="3" r="2"/><circle cx="20" cy="12" r="2"/><circle cx="12" cy="21" r="2"/><circle cx="4" cy="12" r="2"/>',bangle:'<ellipse cx="12" cy="12" rx="8" ry="9"/><ellipse cx="12" cy="12" rx="5" ry="6"/>',chain:'<rect x="1" y="7" width="13" height="8" rx="4" transform="rotate(-35 7 11)"/><rect x="10" y="9" width="13" height="8" rx="4" transform="rotate(-35 17 13)"/>'};
 function hydrate(scope=activeRoot){
  $$('[data-dsc-icon]',scope).forEach(el=>{const [type,name]=el.dataset.dscIcon.split(':');const raw=extraIcons[name];el.innerHTML=raw?`<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${raw}</svg>`:type==='shape'?window.CollectionIcons.shape(name,32):type==='setting'?window.CollectionIcons.style(name,32):window.CollectionIcons.icon(name,20);});
 }
 function strings(){try{return JSON.parse($('[data-dsc-strings]').textContent);}catch{return {};}}
 function route(value,preserveFilters=false){
  const u=new URL(value,location.origin),current=new URL(location.href);
  if(u.origin!==location.origin)return u;
  const base=activeRoot?.dataset.rootUrl||'/';
  if(base!=='/'&&/^\/(collections|products|pages|cart|search)(\/|$)/.test(u.pathname))u.pathname=base.replace(/\/$/,'')+u.pathname;
  if(activeRoot?.dataset.previewThemeId)u.searchParams.set('preview_theme_id',activeRoot.dataset.previewThemeId);
  else if(current.searchParams.has('preview_theme_id'))u.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
  for(const k of ['_ab','_fd','_sc'])if(current.searchParams.has(k))u.searchParams.set(k,current.searchParams.get(k));
  if(preserveFilters){for(const k of new Set(current.searchParams.keys())){if((k.startsWith('filter.')||k==='sort_by')&&!u.searchParams.has(k))current.searchParams.getAll(k).forEach(v=>u.searchParams.append(k,v));}}
  return u;
 }
 function setupLinks(){
  $$('a[href]').forEach(a=>{try{const href=a.getAttribute('href');if(href.startsWith('#'))return;if(new URL(a.href).origin===location.origin)a.href=route(href).href;}catch{}});
  const base=$('[data-dsc-base-url]')?.dataset.dscBaseUrl||activeRoot.dataset.collectionUrl;
  $$('[data-dsc-reset]').forEach(a=>a.href=route(base).href);
  $$('[data-dsc-navigate]').forEach(a=>{if(!a.hasAttribute('data-dsc-native-filter'))a.href=route(a.getAttribute('href'),true).href;});
 }
 function syncFilterPanel(){const panel=$('.dsc-filters'),host=$('.dsc-filter-host'),dialog=$('.dsc-filter-dialog');if(!panel||!dialog)return;const narrow=matchMedia('(max-width:900px)').matches;if(!narrow){if(dialog.open)dialog.close();if(panel.parentElement!==host)host.append(panel);}else{const body=$('.dsc-filter-body');if(panel.parentElement!==body)body.append(panel);}}
 function closeFilters(){const dialog=$('.dsc-filter-dialog');if(dialog?.open)dialog.close();}
 function stopInfinite(){infiniteObserver?.disconnect();infiniteObserver=null;}
 function scrollStatus(state){
  const pagination=$('[data-dsc-pagination]');if(!pagination)return;
  pagination.dataset.scrollState=state;
  const status=$('[data-dsc-scroll-status]',pagination),shown=$('[data-dsc-shown]',pagination);
  const label=pagination.dataset.shownLabel.replace('[count]',String($$('[data-dsc-grid] [data-dsc-card]').length));
  if(shown)shown.textContent=label;
  if(status){status.hidden=false;status.textContent=state==='loading'?pagination.dataset.loadingLabel:state==='error'?pagination.dataset.errorLabel:!pagination.dataset.nextUrl?pagination.dataset.endLabel:'';}
 }
 function setupInfinite(){
  stopInfinite();const root=activeRoot,pagination=$('[data-dsc-pagination]');
  if(!pagination)return;const automaticSupported=!!window.IntersectionObserver;
  if(automaticSupported){pagination.dataset.infinite='true';$('[data-dsc-pages]',pagination).hidden=true;}
  const more=$('[data-dsc-more]',pagination);if(more){more.hidden=automaticSupported&&!autoFailed;more.removeAttribute('aria-disabled');if(autoFailed)more.textContent=pagination.dataset.retryLabel;}
  scrollStatus(loading?'loading':autoFailed?'error':'ready');
  if(!automaticSupported||loading||autoFailed||!pagination.dataset.nextUrl||document.hidden)return;
  infiniteObserver=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting)||root!==activeRoot||!pagination.isConnected||loading||autoFailed||document.hidden||document.querySelector('dialog[open]'))return;
   navigate(pagination.dataset.nextUrl,{history:false,append:true,automatic:true});
  },{rootMargin:'0px 0px 650px 0px',threshold:0});
  infiniteObserver.observe(pagination);
 }
 function init(root){
  if(!root)return;stopInfinite();activeRoot=root;autoFailed=false;
  const str=strings();root.dscStrings=str;
  hydrate();setupLinks();syncFilterPanel();
  const header=document.querySelector('[data-ds-shared-header]');const measureHeader=()=>activeRoot?.style.setProperty('--dsc-sticky-offset',Math.ceil(header?.getBoundingClientRect().height||0)+16+'px');measureHeader();if(header&&!headerObserver&&window.ResizeObserver){headerObserver=new ResizeObserver(measureHeader);headerObserver.observe(header);}
  const params=new URLSearchParams(location.search),form=$('[data-dsc-price-form]');
  for(const key of ['gte','lte']){const input=$(`[name="filter.v.price.${key}"]`,form);if(input)input.value=params.get(`filter.v.price.${key}`)||'';}
  const range=$('[data-dsc-price-range]');if(range)range.value=params.get('filter.v.price.lte')||range.max;
  const chips=[];const seen=new Set();
  $$('.dsc-facet[aria-current="true"],.dsc-facet[aria-current="page"]').forEach(a=>{const label=$('.dsc-facet-label',a)?.textContent.trim()||a.textContent.trim();if(!label||seen.has(label)||a.matches('[data-dsc-all],.dsc-facet--all'))return;seen.add(label);chips.push(`<a href="${esc(a.href)}" data-dsc-navigate aria-label="${esc(str.remove_filter+' '+label)}">${esc(label)}<span aria-hidden="true">×</span></a>`);});
  $$('.dsc-native-filter[aria-current="true"]').forEach(a=>{const label=a.childNodes[0]?.textContent.trim();if(label)chips.push(`<a href="${esc(a.href)}" data-dsc-navigate data-dsc-native-filter aria-label="${esc(str.remove_filter+' '+label)}">${esc(label)}<span aria-hidden="true">×</span></a>`);});
  const current=new URL(location.href);const min=params.get('filter.v.price.gte'),max=params.get('filter.v.price.lte');
  if(min||max){current.searchParams.delete('filter.v.price.gte');current.searchParams.delete('filter.v.price.lte');current.searchParams.delete('page');const fmt=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency,maximumFractionDigits:2}).format(Number(n));chips.push(`<a href="${esc(current.href)}" data-dsc-price-clear>${esc(str.price+': '+fmt(min||0)+' – '+(max?fmt(max):'∞'))}<span aria-hidden="true">×</span></a>`);}
  $('[data-dsc-active-filters]').innerHTML=chips.join('');
  $('[data-dsc-filter-count]').textContent=chips.length?`(${chips.length})`:'';
  try{const density=sessionStorage.getItem('ds-collection-density')||'standard';root.dataset.density=density;$$('[data-dsc-density]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.dscDensity===density));}catch{}
  const dialog=$('.dsc-filter-dialog');dialog?.addEventListener('close',()=>{syncFilterPanel();$('[data-dsc-open-filters]')?.focus({preventScroll:true});});
  document.dispatchEvent(new CustomEvent('ds:collection:updated',{detail:{root}}));
  setupInfinite();
 }
 function setStatus(text,busy=false,problem=false){const el=$('[data-dsc-status]');if(el){el.textContent=text;el.dataset.state=busy?'loading':problem?'error':'ready';}activeRoot?.setAttribute('aria-busy',String(busy));}
 async function navigate(value,{history=true,append=false,automatic=false,kind='filter'}={}){
  if(append&&loading)return;
  stopInfinite();loading=true;autoFailed=false;
  const url=route(value),ticket=++serial;controller?.abort();controller=new AbortController();const oldRoot=activeRoot;
  const keepFilters=!append&&$('.dsc-filter-dialog')?.open;
  if(append){scrollStatus('loading');$('[data-dsc-more]')?.setAttribute('aria-disabled','true');$('[data-dsc-grid]')?.setAttribute('aria-busy','true');}
  else{setStatus(strings().loading,true);closeFilters();}
  const focused=document.activeElement;
  try{
   const response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
   if(!response.ok)throw Error('Collection request failed');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html'),incoming=doc.querySelector('[data-ds-collection]');
   if(ticket!==serial||oldRoot!==activeRoot||!oldRoot.isConnected)return;
   if(!incoming){if(append)throw Error('Collection response is incomplete');location.assign(url.href);return;}
   if(append){
    const grid=$('[data-dsc-grid]'),pagination=$('[data-dsc-pagination]'),next=incoming.querySelector('[data-dsc-pagination]');
    if(!next||incoming.dataset.collectionUrl!==oldRoot.dataset.collectionUrl||Number(next.dataset.currentPage)!==Number(pagination.dataset.currentPage)+1)throw Error('Collection page did not advance');
    const known=new Set($$('[data-dsc-grid] [data-dsc-card]').map(p=>p.dataset.productId)),inserted=[];
    incoming.querySelectorAll('[data-dsc-grid] [data-dsc-card]').forEach(card=>{const key=card.dataset.productId;if(key&&!known.has(key)){inserted.push(card);known.add(key);}});
    if(!inserted.length)throw Error('No new collection products');
    const fragment=document.createDocumentFragment();inserted.forEach(card=>fragment.append(card));grid.append(fragment);
    // Retain the live status node so assistive technology can announce each update.
    const status=$('[data-dsc-scroll-status]',pagination);if(status)$('[data-dsc-scroll-status]',next)?.replaceWith(status);
    pagination.replaceWith(next);
    hydrate();setupLinks();document.dispatchEvent(new CustomEvent('ds:collection:updated',{detail:{root:activeRoot}}));
    document.dispatchEvent(new CustomEvent('ds:collection:page-appended',{detail:{page:Number(next.dataset.currentPage)}}));
    if(!automatic)inserted[0]?.querySelector('a,button')?.focus({preventScroll:true});
   }else{
    const actual=url.pathname+url.search;
    if(history)window.history.pushState({dsCollection:true},'',actual);
    oldRoot.replaceWith(incoming);init(incoming);document.title=doc.title;
    document.dispatchEvent(new CustomEvent('ds:collection:navigated',{detail:{kind:['filter','sort','history','reset','page'].includes(kind)?kind:'filter',resultCount:Number($('[data-dsc-pagination]')?.dataset.total||0)}}));
    const canonical=doc.querySelector('link[rel="canonical"]'),currentCanonical=document.querySelector('link[rel="canonical"]');if(canonical&&currentCanonical)currentCanonical.href=canonical.href;
    setStatus($('[data-dsc-count]')?.textContent||strings().results);
    if(keepFilters){const d=$('.dsc-filter-dialog');$('.dsc-filter-body').append($('.dsc-filters'));d.showModal();}else{
    $('.dsc-toolbar').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    const status=$('[data-dsc-status]');status.tabIndex=-1;status.focus({preventScroll:true});
    }
   }
  }catch(error){if(error.name==='AbortError')return;if(ticket!==serial)return;autoFailed=true;if(append){scrollStatus('error');}else{const str=strings();setStatus(str.error,false,true);const a=document.createElement('a');a.href=url.href;a.textContent=str.retry;a.dataset.dscFullNavigation='';$('[data-dsc-status]').append(' ',a);focused?.isConnected&&focused.focus({preventScroll:true});}}
  finally{if(ticket===serial){loading=false;activeRoot?.setAttribute('aria-busy','false');$('[data-dsc-grid]')?.setAttribute('aria-busy','false');setupInfinite();}}
 }
 document.addEventListener('click',e=>{
  const b=e.target.closest('a,button');if(!b||!activeRoot?.contains(b))return;
  if(b.matches('[data-dsc-open-filters]')){const d=$('.dsc-filter-dialog'),p=$('.dsc-filters');$('.dsc-filter-body').append(p);d.showModal();return;}
  if(b.matches('[data-dsc-close-filters]')){closeFilters();syncFilterPanel();return;}
  if(b.matches('[data-dsc-density]')){activeRoot.dataset.density=b.dataset.dscDensity;$$('[data-dsc-density]').forEach(x=>x.setAttribute('aria-pressed',x===b));try{sessionStorage.setItem('ds-collection-density',b.dataset.dscDensity);}catch{}return;}
  if(e.button!==0||e.ctrlKey||e.metaKey||e.altKey||e.shiftKey)return;
  if(b.matches('[data-dsc-navigate],[data-dsc-reset],[data-dsc-price-clear],[data-dsc-more],[data-dsc-pages] a')){e.preventDefault();navigate(b.href,{append:b.hasAttribute('data-dsc-more'),kind:b.matches('[data-dsc-reset]')?'reset':b.matches('[data-dsc-pages] a')?'page':'filter'});}
 });
 document.addEventListener('submit',e=>{const form=e.target.closest('[data-dsc-price-form]');if(!form)return;e.preventDefault();const data=new FormData(form),min=Number(data.get('filter.v.price.gte')||0),max=Number(data.get('filter.v.price.lte')||0);const maxInput=$('[name="filter.v.price.lte"]',form);maxInput.setCustomValidity(data.get('filter.v.price.lte')!==''&&max<min?strings().invalid_price:'');if(!form.reportValidity())return;const u=route(location.href);for(const key of ['filter.v.price.gte','filter.v.price.lte']){const value=data.get(key);if(value!==''&&value!==null)u.searchParams.set(key,value);else u.searchParams.delete(key);}u.searchParams.delete('page');navigate(u.href);});
 document.addEventListener('change',e=>{const el=e.target;if(!activeRoot?.contains(el))return;if(el.matches('[data-dsc-sort]')){const u=route(location.href);u.searchParams.set('sort_by',el.value);u.searchParams.delete('page');navigate(u.href,{kind:'sort'});}});
 document.addEventListener('input',e=>{if(e.target.matches('[data-dsc-price-range]')){const max=$('[name="filter.v.price.lte"]');max.value=e.target.value;max.setCustomValidity('');}if(e.target.matches('[name="filter.v.price.lte"],[name="filter.v.price.gte"]'))$('[name="filter.v.price.lte"]').setCustomValidity('');});
 document.addEventListener('click',e=>{const d=$('.dsc-filter-dialog');if(e.target!==d||!d?.open)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){closeFilters();syncFilterPanel();}});
 window.addEventListener('popstate',()=>{if(activeRoot)navigate(location.href,{history:false,kind:'history'});});
 document.addEventListener('close',()=>{if(!loading)setupInfinite();},true);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stopInfinite();else if(!loading)setupInfinite();});
 matchMedia('(max-width:900px)').addEventListener('change',syncFilterPanel);
 const boot=()=>{const root=document.querySelector('[data-ds-collection]');if(root)init(root);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
 window.DSCollection={init,route,navigate,hydrate};
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-homepage-native-build-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupProductCarousels = () => {
      document.querySelectorAll('[data-ds-product-carousel]').forEach((carousel) => {
        if (carousel.dataset.dsReady === 'true') return;
        carousel.dataset.dsReady = 'true';
        const slides = Array.from(carousel.querySelectorAll('[data-ds-carousel-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-ds-carousel-dot]'));
        const prev = carousel.querySelector('[data-ds-carousel-prev]');
        const next = carousel.querySelector('[data-ds-carousel-next]');
        const track = carousel.querySelector('[data-ds-product-swipe-track]');
        const mobileQuery = window.matchMedia('(max-width: 740px)');
        let index = 0;
        let originalWidth = 0;
        let resettingLoop = false;
        const ensureLoopClones = () => {
          if (!track || !mobileQuery.matches || track.dataset.dsLoopReady === 'true') return;
          const before = slides.map((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.remove('is-active');
            clone.setAttribute('aria-hidden', 'true');
            clone.dataset.dsLoopClone = 'before';
            return clone;
          });
          const after = slides.map((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.remove('is-active');
            clone.setAttribute('aria-hidden', 'true');
            clone.dataset.dsLoopClone = 'after';
            return clone;
          });
          before.reverse().forEach((clone) => track.insertBefore(clone, track.firstChild));
          after.forEach((clone) => track.appendChild(clone));
          track.dataset.dsLoopReady = 'true';
          window.requestAnimationFrame(() => {
            originalWidth = slides.reduce((width, slide) => width + slide.offsetWidth, 0) + Math.max(0, slides.length - 1) * 16;
            if (originalWidth > 0) track.scrollLeft = originalWidth;
          });
        };
        const normalizeLoopPosition = () => {
          if (!track || !mobileQuery.matches || !originalWidth || resettingLoop) return;
          const edge = Math.max(24, track.clientWidth * 0.18);
          if (track.scrollLeft < edge) {
            resettingLoop = true;
            track.scrollLeft += originalWidth;
            window.requestAnimationFrame(() => { resettingLoop = false; });
          } else if (track.scrollLeft > originalWidth * 2 - edge) {
            resettingLoop = true;
            track.scrollLeft -= originalWidth;
            window.requestAnimationFrame(() => { resettingLoop = false; });
          }
        };
        const setActive = (nextIndex) => {
          if (!slides.length) return;
          index = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };
        const scrollToActive = (behavior = 'smooth') => {
          if (!track || !slides[index] || !mobileQuery.matches) return;
          const left = slides[index].offsetLeft - track.offsetLeft;
          track.scrollTo({ left, behavior });
        };
        const show = (nextIndex, behavior = 'smooth') => {
          setActive(nextIndex);
          scrollToActive(behavior);
        };
        const updateFromScroll = () => {
          if (!track || !slides.length || !mobileQuery.matches) return;
          normalizeLoopPosition();
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          slides.forEach((slide, slideIndex) => {
            const left = slide.offsetLeft - track.offsetLeft;
            const distance = Math.abs(left - track.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = slideIndex;
            }
          });
          setActive(closestIndex);
        };
        let scrollFrame = null;
        track?.addEventListener('scroll', () => {
          if (!mobileQuery.matches) return;
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateFromScroll);
        }, { passive: true });
        prev?.addEventListener('click', () => show(index - 1));
        next?.addEventListener('click', () => show(index + 1));
        dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
        mobileQuery.addEventListener?.('change', () => {
          ensureLoopClones();
          show(index, 'auto');
        });
        ensureLoopClones();
        show(0, 'auto');
      });
    };

    const setupScrollCarousels = () => {
      document.querySelectorAll('[data-ds-scroll-carousel]').forEach((carousel) => {
        if (carousel.dataset.dsReady === 'true') return;
        carousel.dataset.dsReady = 'true';
        const track = carousel.querySelector('[data-ds-scroll-track]');
        const prev = carousel.querySelector('[data-ds-scroll-prev]');
        const next = carousel.querySelector('[data-ds-scroll-next]');
        const mobileQuery = window.matchMedia('(max-width: 740px)');
        let originalWidth = 0;
        let resettingLoop = false;
        const ensureLoopClones = () => {
          if (!track || !mobileQuery.matches || track.dataset.dsLoopReady === 'true') return;
          const items = Array.from(track.children);
          if (items.length < 2) return;
          const before = items.map((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.dataset.dsLoopClone = 'before';
            return clone;
          });
          const after = items.map((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.dataset.dsLoopClone = 'after';
            return clone;
          });
          before.reverse().forEach((clone) => track.insertBefore(clone, track.firstChild));
          after.forEach((clone) => track.appendChild(clone));
          track.dataset.dsLoopReady = 'true';
          window.requestAnimationFrame(() => {
            originalWidth = items.reduce((width, item) => width + item.offsetWidth, 0) + Math.max(0, items.length - 1) * 14;
            if (originalWidth > 0) track.scrollLeft = originalWidth;
          });
        };
        const normalizeLoopPosition = () => {
          if (!track || !mobileQuery.matches || !originalWidth || resettingLoop) return;
          const edge = Math.max(24, track.clientWidth * 0.2);
          if (track.scrollLeft < edge) {
            resettingLoop = true;
            track.scrollLeft += originalWidth;
            window.requestAnimationFrame(() => { resettingLoop = false; });
          } else if (track.scrollLeft > originalWidth * 2 - edge) {
            resettingLoop = true;
            track.scrollLeft -= originalWidth;
            window.requestAnimationFrame(() => { resettingLoop = false; });
          }
        };
        const moveGrid = (direction) => {
          if (!track) return;
          const items = Array.from(track.children).filter((item) => !item.dataset.dsLoopClone);
          if (items.length < 2) return;
          if (direction > 0) {
            track.appendChild(items[0]);
          } else {
            track.insertBefore(items[items.length - 1], items[0]);
          }
        };
        const advance = (direction) => {
          if (!track) return;
          if (window.matchMedia('(min-width: 741px)').matches) {
            moveGrid(direction);
            return;
          }
          track.scrollBy({ left: direction * track.clientWidth * 0.78, behavior: 'smooth' });
        };
        ensureLoopClones();
        track?.addEventListener('scroll', () => {
          if (!mobileQuery.matches) return;
          window.requestAnimationFrame(normalizeLoopPosition);
        }, { passive: true });
        mobileQuery.addEventListener?.('change', ensureLoopClones);
        prev?.addEventListener('click', () => advance(-1));
        next?.addEventListener('click', () => advance(1));
      });
    };

    const setupSwipeRails = () => {
      document.querySelectorAll('[data-ds-swipe-rail]').forEach((rail) => {
        const isCategoryRail = rail.classList.contains('ds-native-home__categories');
        rail.style.scrollSnapType = isCategoryRail ? 'x mandatory' : 'x proximity';
        rail.style.touchAction = 'pan-x pan-y';
        rail.querySelectorAll('.ds-native-home__category, .ds-native-home-v3__product-slide, img').forEach((item) => {
          item.style.scrollSnapStop = 'normal';
          item.draggable = false;
          item.setAttribute('draggable', 'false');
        });
        if (rail.dataset.dsSwipeReady === 'true') return;
        rail.dataset.dsSwipeReady = 'true';
        const mobileQuery = window.matchMedia('(max-width: 1180px)');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let autoTimer = null;
        let autoVisible = false;
        let autoPaused = false;
        let isDragging = false;
        let moved = false;
        let startX = 0;
        let startLeft = 0;
        let startY = 0;
        let isHorizontal = false;
        let hasPointerCapture = false;
        let pointerDownHref = '';

        const clearAutoTimer = () => {
          if (!autoTimer) return;
          window.clearTimeout(autoTimer);
          autoTimer = null;
        };

        const getNextAutoTarget = () => {
          const cards = Array.from(rail.querySelectorAll('.ds-native-home__category'));
          if (cards.length < 2) return null;
          const firstLeft = cards[0].offsetLeft;
          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const targets = cards
            .map((card) => Math.min(Math.max(0, card.offsetLeft - firstLeft), maxScroll))
            .filter((target, index, list) => index === 0 || Math.abs(target - list[index - 1]) > 8);
          return targets.find((target) => target > rail.scrollLeft + 8) ?? null;
        };

        const scheduleCategoryAutoSwipe = () => {
          if (!isCategoryRail) return;
          clearAutoTimer();
          if (!mobileQuery.matches || reduceMotion.matches || !autoVisible || autoPaused || rail.scrollWidth <= rail.clientWidth + 4) return;
          autoTimer = window.setTimeout(() => {
            const nextLeft = getNextAutoTarget();
            if (nextLeft === null) return;
            rail.scrollTo({ left: nextLeft, behavior: 'smooth' });
            scheduleCategoryAutoSwipe();
          }, 3000);
        };

        const pauseCategoryAutoSwipe = () => {
          if (!isCategoryRail) return;
          autoPaused = true;
          clearAutoTimer();
        };

        rail.addEventListener('pointerdown', (event) => {
          pauseCategoryAutoSwipe();
          if (event.pointerType && event.pointerType !== 'mouse') return;
          if (event.button !== undefined && event.button !== 0) return;
          if (event.isPrimary === false) return;
          const categoryLink = isCategoryRail && event.target.closest?.('.ds-native-home__category[href]');
          pointerDownHref = categoryLink ? categoryLink.href : '';
          if (rail.scrollWidth <= rail.clientWidth + 4) return;
          isDragging = true;
          moved = false;
          startX = event.clientX;
          startY = event.clientY;
          startLeft = rail.scrollLeft;
          isHorizontal = false;
          hasPointerCapture = false;
          if (event.pointerId !== undefined) {
            rail.setPointerCapture?.(event.pointerId);
            hasPointerCapture = true;
          }
          event.preventDefault();
        });

        rail.addEventListener('pointermove', (event) => {
          if (!isDragging) return;
          const delta = event.clientX - startX;
          const verticalDelta = event.clientY - startY;
          if (!isHorizontal && Math.abs(delta) < 6 && Math.abs(verticalDelta) < 6) return;
          if (!isHorizontal && Math.abs(verticalDelta) > Math.abs(delta)) {
            stopDragging(event);
            return;
          }
          isHorizontal = true;
          if (Math.abs(delta) > 4) {
            moved = true;
            rail.classList.add('is-dragging');
            if (!hasPointerCapture && event.pointerId !== undefined) {
              rail.setPointerCapture?.(event.pointerId);
              hasPointerCapture = true;
            }
            rail.scrollLeft = startLeft - delta;
            event.preventDefault();
          }
        });

        const stopDragging = (event) => {
          if (!isDragging) return;
          isDragging = false;
          rail.classList.remove('is-dragging');
          if (hasPointerCapture && event?.pointerId !== undefined) {
            rail.releasePointerCapture?.(event.pointerId);
          }
          hasPointerCapture = false;
        };

        rail.addEventListener('pointerup', stopDragging);
        rail.addEventListener('pointercancel', stopDragging);
        rail.addEventListener('mouseleave', stopDragging);
        rail.addEventListener('touchstart', pauseCategoryAutoSwipe, { passive: true });
        rail.addEventListener('wheel', pauseCategoryAutoSwipe, { passive: true });
        rail.addEventListener('click', (event) => {
          const categoryLink = isCategoryRail && event.target.closest?.('.ds-native-home__category[href]');
          const categoryHref = categoryLink ? categoryLink.href : pointerDownHref;
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
            moved = false;
            pointerDownHref = '';
            return;
          }
          if (categoryHref) {
            event.preventDefault();
            window.location.href = categoryHref;
            pointerDownHref = '';
          }
        }, true);

        if (isCategoryRail) {
          if ('IntersectionObserver' in window) {
            const autoObserver = new IntersectionObserver((entries) => {
              autoVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35);
              if (autoVisible) {
                scheduleCategoryAutoSwipe();
              } else {
                clearAutoTimer();
              }
            }, { threshold: [0, 0.2, 0.35, 0.6, 1] });
            autoObserver.observe(rail);
          } else {
            autoVisible = true;
            scheduleCategoryAutoSwipe();
          }

          const handleAutoChange = () => {
            if (mobileQuery.matches && autoVisible) {
              scheduleCategoryAutoSwipe();
            } else {
              clearAutoTimer();
            }
          };

          if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', handleAutoChange);
            reduceMotion.addEventListener?.('change', handleAutoChange);
          } else {
            mobileQuery.addListener(handleAutoChange);
            reduceMotion.addListener(handleAutoChange);
          }
        }
      });
    };

    const setupScrollVideos = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      document.querySelectorAll('[data-ds-scroll-video], [data-ds-lazy-scroll-video]').forEach((video) => {
        if (video.dataset.dsScrollVideoReady === 'true') return;
        video.dataset.dsScrollVideoReady = 'true';
        const target = video.closest('.ds-native-home__hero-media, .ds-native-home__split-media, .ds-native-home__shapes-media, .ds-native-home__product-media, .ds-native-home__visit-media, .ds-native-home__vision-media') || video;
        const loadSources = () => {
          if (video.dataset.dsScrollVideoLoaded === 'true') return;
          let hasPendingSource = false;
          video.querySelectorAll('source[data-src]').forEach((source) => {
            if (!source.dataset.src) return;
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
            hasPendingSource = true;
          });
          if (video.dataset.dsLazySrc) {
            const source = document.createElement('source');
            source.src = video.dataset.dsLazySrc;
            source.type = video.dataset.dsLazyType || 'video/mp4';
            video.appendChild(source);
            video.removeAttribute('data-ds-lazy-src');
            hasPendingSource = true;
          }
          video.dataset.dsScrollVideoLoaded = 'true';
          if (hasPendingSource) video.load();
        };
        const pauseAndReset = () => {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (error) {}
        };
        const playVideo = () => {
          if (reduceMotion.matches) {
            pauseAndReset();
            return;
          }
          loadSources();
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };
        pauseAndReset();
        reduceMotion.addEventListener?.('change', pauseAndReset);
        if (!('IntersectionObserver' in window)) {
          playVideo();
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              playVideo();
            } else {
              pauseAndReset();
            }
          });
        }, {
          threshold: [0, 0.2, 0.35, 0.6, 1]
        });
        observer.observe(target);
      });
    };

    setupProductCarousels();
    setupScrollCarousels();
    setupSwipeRails();
    setupScrollVideos();
    document.addEventListener('shopify:section:load', () => {
      setupProductCarousels();
      setupScrollCarousels();
      setupSwipeRails();
      setupScrollVideos();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-lab-grown-jewelry-guides-test"]) return;
  try {
    
  document.querySelectorAll('[data-ds-journal-social]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ds-journal-social-track]');
    const prev = carousel.querySelector('[data-ds-journal-social-prev]');
    const next = carousel.querySelector('[data-ds-journal-social-next]');

    if (!track || !prev || !next) {
      return;
    }

    const getDistance = () => {
      const firstImage = track.querySelector('img');
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      return firstImage ? firstImage.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getDistance(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-native-homepage-preview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ds-home-scroll]');
    if (!button) {
      return;
    }
    var section = button.closest('.ds-home-preview__section');
    if (!section) {
      return;
    }
    var row = section.querySelector('.ds-home-preview__product-row');
    if (!row) {
      return;
    }
    row.scrollBy({ left: Number(button.dataset.dsHomeScroll) * row.clientWidth * 0.75, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-ugc-reels-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupUgcReels = () => {
      document.querySelectorAll('[data-ds-ugc-reels]').forEach((section) => {
        if (section.dataset.dsUgcReady === 'true') return;
        section.dataset.dsUgcReady = 'true';
        const track = section.querySelector('[data-ds-ugc-track]');
        const videos = Array.from(section.querySelectorAll('video'));

        if (track) {
          let autoTimer = null;
          let autoResumeTimer = null;
          let autoVisible = false;
          let autoPaused = false;
          let dragActive = false;
          let dragged = false;
          let startX = 0;
          let startScrollLeft = 0;

          const clearAutoTimer = () => {
            if (!autoTimer) return;
            window.clearTimeout(autoTimer);
            autoTimer = null;
          };

          const getAutoStep = () => {
            const card = track.querySelector('.ds-ugc-reels__card');
            const styles = window.getComputedStyle(track);
            const gap = parseFloat(styles.columnGap || styles.gap || 0);
            return (card?.getBoundingClientRect().width || track.clientWidth * 0.8) + (Number.isNaN(gap) ? 0 : gap);
          };

          const scheduleAutoSwipe = () => {
            clearAutoTimer();
            if (!autoVisible || autoPaused || track.scrollWidth <= track.clientWidth + 4) return;
            autoTimer = window.setTimeout(() => {
              const maxScroll = track.scrollWidth - track.clientWidth;
              const nextLeft = track.scrollLeft + getAutoStep();
              if (nextLeft >= maxScroll - 4) {
                track.scrollTo({ left: 0, behavior: 'smooth' });
              } else {
                track.scrollTo({ left: nextLeft, behavior: 'smooth' });
              }
              scheduleAutoSwipe();
            }, 2000);
          };

          const pauseAutoSwipe = () => {
            autoPaused = true;
            clearAutoTimer();
            window.clearTimeout(autoResumeTimer);
            autoResumeTimer = window.setTimeout(() => {
              autoPaused = false;
              scheduleAutoSwipe();
            }, 5000);
          };

          const startDrag = (event, x) => {
            pauseAutoSwipe();
            dragActive = true;
            dragged = false;
            startX = x;
            startScrollLeft = track.scrollLeft;
            track.classList.add('is-dragging');
          };

          const moveDrag = (event, x) => {
            if (!dragActive) return;
            const delta = x - startX;
            if (Math.abs(delta) > 4) dragged = true;
            track.scrollLeft = startScrollLeft - delta;
            event.preventDefault();
          };

          const endDrag = () => {
            if (!dragActive) return;
            dragActive = false;
            track.classList.remove('is-dragging');
          };

          track.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'touch') {
              pauseAutoSwipe();
              return;
            }
            if (event.button !== 0) return;
            startDrag(event, event.clientX);
            track.setPointerCapture(event.pointerId);
          });

          track.addEventListener('pointermove', (event) => {
            moveDrag(event, event.clientX);
          });

          track.addEventListener('pointerup', (event) => {
            endDrag();
            if (track.hasPointerCapture(event.pointerId)) {
              track.releasePointerCapture(event.pointerId);
            }
          });
          track.addEventListener('pointercancel', endDrag);
          track.addEventListener('mousedown', (event) => {
            if (event.button !== 0) return;
            startDrag(event, event.clientX);
          });
          track.addEventListener('touchstart', pauseAutoSwipe, { passive: true });
          track.addEventListener('wheel', pauseAutoSwipe, { passive: true });
          window.addEventListener('mousemove', (event) => {
            moveDrag(event, event.clientX);
          });
          window.addEventListener('mouseup', endDrag);
          track.addEventListener('mouseleave', () => {
            dragActive = false;
            track.classList.remove('is-dragging');
          });
          track.addEventListener('click', (event) => {
            if (!dragged) return;
            event.preventDefault();
            event.stopPropagation();
            dragged = false;
          }, true);

          if ('IntersectionObserver' in window) {
            const autoObserver = new IntersectionObserver((entries) => {
              autoVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35);
              if (autoVisible) {
                scheduleAutoSwipe();
              } else {
                clearAutoTimer();
              }
            }, { threshold: [0, 0.2, 0.35, 0.6, 1] });
            autoObserver.observe(section);
          } else {
            autoVisible = true;
            scheduleAutoSwipe();
          }

          window.addEventListener('resize', scheduleAutoSwipe);
        }

        videos.forEach((video) => {
          video.addEventListener('canplay', () => video.play().catch(() => {}), { once: true });
          video.play().catch(() => {});
        });
      });
    };
    setupUgcReels();
    document.addEventListener('shopify:section:load', setupUgcReels);
  })();

  } catch(e) { console.error(e); }
})();
})();
